import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useQuery } from 'react-query';
import {
  Col, DatePicker, Row,
} from 'antd';
import moment from 'moment';

import {
  getDatasetFavoritesAnalytics,
  getDatasetAlertsAnalytics,
  getObsDatasetViewsAnalytics,
  getObsDatasetDownloadsAnalytics,
} from '../../../services/dataset.service';
import AnalyticsCard from './AnalyticsCard';

const { RangePicker } = DatePicker;

const AnalyticsTab = (props) => {
  const { obsDatasetSummary } = props;

  // 90 days, not a year: the Views/Downloads cards each fire a GA4 runReport,
  // and a year-wide report over pagePath/pageLocation exceeds the API Gateway
  // 29s integration timeout and comes back as a 504. Managers can still widen
  // the range manually with the picker below.
  const defaultRange = [
    moment().subtract(90, 'days'),
    moment(),
  ];

  const [dateRange, setDateRange] = useState(defaultRange);

  console.log('obsDatasetSummary', obsDatasetSummary);

  const formattedStartDate = dateRange?.[0]?.format('YYYY-MM-DD');
  const formattedEndDate = dateRange?.[1]?.format('YYYY-MM-DD');

  const {
    data: obsDatasetFavorites,
    isLoading: favoritesIsLoading,
  } = useQuery(
    ['obsDatasetFavoritesAnalytics', obsDatasetSummary.obs_dataset_id, formattedStartDate, formattedEndDate],
    () => getDatasetFavoritesAnalytics(obsDatasetSummary.obs_dataset_id, formattedStartDate, formattedEndDate), {
      refetchOnWindowFocus: false,
      enabled: !!obsDatasetSummary.obs_dataset_id,
    },
  );

  const {
    data: obsDatasetAlerts,
    isLoading: alertsIsLoading,
  } = useQuery(
    ['obsDatasetFavorites', obsDatasetSummary.obs_dataset_id, formattedStartDate, formattedEndDate],
    () => getDatasetAlertsAnalytics(obsDatasetSummary.obs_dataset_id, formattedStartDate, formattedEndDate), {
      refetchOnWindowFocus: false,
      enabled: !!obsDatasetSummary.obs_dataset_id,
    },
  );

  const {
    data: obsDatasetViews,
    isLoading: viewsIsLoading,
  } = useQuery(
    ['obsDatasetViewsAnalytics', obsDatasetSummary.obs_dataset_id, formattedStartDate, formattedEndDate],
    () => getObsDatasetViewsAnalytics(obsDatasetSummary.obs_dataset_id, formattedStartDate, formattedEndDate), {
      refetchOnWindowFocus: false,
      enabled: !!obsDatasetSummary.obs_dataset_id,
    },
  );

  const {
    data: obsDatasetDownloads,
    isLoading: downloadsIsLoading,
  } = useQuery(
    ['obsDatasetDownloadsAnalytics', obsDatasetSummary.obs_dataset_id, formattedStartDate, formattedEndDate],
    () => getObsDatasetDownloadsAnalytics(obsDatasetSummary.obs_dataset_id, formattedStartDate, formattedEndDate), {
      refetchOnWindowFocus: false,
      enabled: !!obsDatasetSummary.obs_dataset_id,
    },
  );

  const handleDateChange = (dates) => {
    if (!dates || dates.length !== 2) {
      setDateRange(defaultRange);
      return;
    }

    setDateRange(dates);
  };

  return (
    <div>
      <div
        className="deployment-date-picker-container"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          gap: 10,
        }}
      >
        <label
          style={{
            color: '#D9E0E4',
          }}
        >
          Date Range:
        </label>
        <RangePicker
          // TODO: generalize this classname
          className="deployment-date-picker"
          // keeps dropdown from showing up behind the modal
          getPopupContainer={(triggerNode) => triggerNode.parentNode}
          format="YYYY-MM-DD"
          value={dateRange}
          onChange={handleDateChange}
        />
      </div>
      <Row
        gutter={[16, 16]}
        style={{
          marginTop: 16,
        }}
      >
        <Col
          xs={24}
          md={12}
          lg={6}
        >
          <AnalyticsCard
            title="Views"
            statistic={obsDatasetViews?.view_count}
            isLoading={viewsIsLoading}
          />
        </Col>
        <Col
          xs={24}
          md={12}
          lg={6}
        >
          <AnalyticsCard
            title="Downloads"
            statistic={obsDatasetDownloads?.download_count}
            isLoading={downloadsIsLoading}
          />
        </Col>
        <Col
          xs={24}
          md={12}
          lg={6}
        >
          <AnalyticsCard
            title="Favorites"
            statistic={obsDatasetFavorites?.favorites_count}
            isLoading={favoritesIsLoading}
          />
        </Col>
        <Col
          xs={24}
          md={12}
          lg={6}
        >
          <AnalyticsCard
            title="Alerts"
            statistic={obsDatasetAlerts?.alerts_count}
            isLoading={alertsIsLoading}
          />
        </Col>
      </Row>
    </div>
  );
};

AnalyticsTab.propTypes = {
  obsDatasetSummary: PropTypes.object,
};

AnalyticsTab.defaultProps = {
  obsDatasetSummary: {},
};

export default AnalyticsTab;
